// Determine which filters to show based on role
export const getFiltersForRole = (userInfoData) => {
  const role = userInfoData?.ticket_account_type;
  const accountType = userInfoData?.account_type;

  // Cluster managers behave like admins but with gym restrictions
  if (accountType === "cluster_manager") {
    return [
      "search",
      "issueType",
      "category",
      "raisedBy",
      "supervisor",
      "status",
      "priority",
      "dateRange",
      // "gym",
      "issueFilter",
      "ticketType",
      "breached",
    ];
  }

  switch (role) {
    case "admin":
      return [
        "search",
        "issueType",
        "category",
        "raisedBy",
        "supervisor",
        "status",
        "priority",
        "dateRange",
        "gym",
        "breached",
        "issueFilter",
        "ticketType",
      ];
    case "manager":
      return [
        "search",
        "issueType",
        "category",
        "raisedBy",
        "supervisor",
        "status",
        "priority",
        "dateRange",
        "gym",
        "breached",
        "issueFilter",
        "ticketType",
      ];
    case "supervisor":
      return [
        "search",
        "issueType",
        "category",
        "raisedBy",
        "status",
        "priority",
        "dateRange",
        "breached",
        "issueFilter",
        "ticketType",
      ];
    case "receptionist":
      return [
        "search",
        "issueType",
        "category",
        "status",
        "priority",
        "dateRange",
        "breached",
        "issueFilter",
        "ticketType",
        // "gym",
      ];
    default:
      return ["search", "status", "priority", "dateRange", "category"];
  }
};
